import { companyService } from '@/services/CompanyService'
import { ServiceError } from '@/services/util/ServiceError'
import { useProfileStore } from '@/store/profile.module'
import { onMounted, ref, watch } from 'vue'

export function useShowPassengerTransportDocumentCreate() {
  const profileStore = useProfileStore()
  const showPassengerTransportDocumentCreate = ref(false)

  const load = async () => {
    const companyId = profileStore.selectedCompany?.id
    if (!companyId) {
      showPassengerTransportDocumentCreate.value = false
      return
    }

    const response = await companyService.findCompany(companyId)
    showPassengerTransportDocumentCreate.value =
      !(response instanceof ServiceError) &&
      response.config?.showPassengerTransportDocumentCreate === true
  }

  onMounted(load)
  watch(() => profileStore.selectedCompany?.id, load)

  return { showPassengerTransportDocumentCreate }
}
